<template>
    <div id="page">
        <div v-if="$store.state.mobileAsideOpen || $store.state.mobileMenuOpen"
             class="mobile-overlay"
             @click="closeAllMobileMenus"></div>
        <div class="d-flex flex-column flex-root mw-100">
            <div class="page d-flex flex-row flex-column-fluid">
                <slot name="aside">
                    <LeftAside></LeftAside>
                </slot>
                <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                    <slot name="header">
                        <HeaderTop></HeaderTop>
                    </slot>
                    <slot name="toolbar">
                    </slot>
                    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
                        <div class="post d-flex flex-column-fluid" id="kt_post">
                            <div class="container" id="kt_content_container">
                                <EscalationAlert/>
                                <slot name="content">


                                </slot>
                            </div>
                        </div>
                        <div class="pt-20 text-gray-400 text-center">
                            &copy; Copyright WiASSUR 2021
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <slot name="rightModal">

        </slot>
        <!-- Navigation mobile. Montee ici et non dans App.vue : Base.vue est le layout
             de l'espace admin, le comparateur public ne passe pas par lui et n'a donc
             pas a heriter d'une barre de sections. -->
        <MobileTabBar v-if="isConnected"></MobileTabBar>
    </div>
</template>
<script lang="ts">
    import {Component, Vue} from 'vue-property-decorator';


    import HeaderTop from "@/layouts/HeaderTop.vue";
    import {auth} from "@/services/Auth";
    import Toolbar from "@/layouts/Toolbar.vue";
    import LeftAside from "@/layouts/LeftAside.vue";
    import EscalationAlert from "@/components/EscalationAlert.vue";
    import MobileTabBar from "@/layouts/MobileTabBar.vue";


    @Component({
        components: {LeftAside, Toolbar, HeaderTop, EscalationAlert, MobileTabBar}
    })
    export default class Base extends Vue {
        public fixedToolbar = true;
        public toolbarEnabled = true;

        get isConnected(): boolean {
            return auth.isConnected();
        }

        closeAllMobileMenus() {
            this.$store.commit('closeMobileAside');
            this.$store.commit('closeMobileMenu');
        }

        mounted(): void {
            this.$watch(() => this.$route, () => {
                this.closeAllMobileMenus();
            });
        }
    }
</script>
<style scoped>
    #page{
        max-width: 100%;
    }
</style>
<style>
    .mobile-overlay {
        display: none;
    }
    @media (max-width: 991.98px) {
        .mobile-overlay {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            z-index: 1045;
        }

        /* LA BARRE DU BAS REMPLACE L'ASIDE.
           Metronic declare `.aside { display: flex }` SANS media query : la colonne
           de 265px restait donc affichee sur telephone, a cote du contenu, dans un
           `d-flex flex-row`. La page devenait plus large que l'ecran et le navigateur
           la reduisait pour la faire tenir -- d'ou l'impression d'un site desktop
           dezoome. Et une barre `position: fixed` se cale sur cette largeur-la, pas
           sur l'ecran : elle finissait hors champ. */
        #kt_aside {
            display: none !important;
        }

        /* Le decalage reserve a l'aside n'a plus lieu d'etre. */
        .aside-enabled.aside-fixed .wrapper,
        .wrapper {
            padding-left: 0 !important;
        }

        /* Un enfant de flex refuse par defaut de descendre sous la largeur de son
           contenu (min-width: auto) : sans ca, un tableau large reimpose le
           debordement horizontal qu'on vient d'enlever. */
        .page,
        .wrapper,
        #kt_content,
        #kt_post,
        #kt_content_container {
            min-width: 0;
            max-width: 100%;
        }

        /* Les deux boutons de tiroir du header disparaissent : la barre du bas les
           remplace, sinon trois chemins menent au meme endroit. */
        #kt_aside_mobile_toggle,
        #kt_header_menu_mobile_toggle {
            display: none !important;
        }

        /* Le contenu se termine au-dessus de la barre, sinon le dernier bouton d'une
           page est sous elle et devient inatteignable. */
        #kt_content {
            padding-bottom: calc(76px + env(safe-area-inset-bottom, 0px));
        }

        /* Une modale ouverte masque la barre : ses boutons sont souvent en bas. */
        body.modal-open .mtb,
        body.swal2-shown .mtb,
        body.swal2-height-auto .mtb {
            display: none !important;
        }
    }
</style>
